<div class="padding-tb10" *ngIf="averageRating >=1" fxLayout="row" fxLayoutAlign="start center"
    fxLayoutGap="10px">
    <div class="review-Rating E_uFuv">
      {{calculateAvgRating | number : '1.1-1'}}
      <span class="material-icons f11" style="font-size: 11px;">
        star_rate
      </span>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <span class="f14 color-gray">{{averageRating}}&nbsp;Ratings</span>
    </div>
  </div>